import React from 'react';
import { Grid, Segment } from 'semantic-ui-react';

// @ts-ignore
import DocumentSetEventStartDate from '../../../../components/DocumentSetEventStartDate';
// @ts-ignore
import DocumentSetEventEndDate from '../../../../components/DocumentSetEventEndDate';
// @ts-ignore
import DocumentSetAssignedUsersList from '../../../../components/DocumentSetAssignedUsersList';
// @ts-ignore
import DocumentSetCreatedAt from '../../../../components/DocumentSetCreatedAt';
// @ts-ignore
import DocumentSetEventEntityDefaultVarietyName from '../../../../components/DocumentSetEventEntityDefaultVarietyName';
// @ts-ignore
import DocumentSetEventGroupName from '../../../../components/DocumentSetEventGroupName';
// @ts-ignore
import DocumentSetProgressBadge from '../../../../components/DocumentSetProgressBadge';
import DocumentSetEventCreatedBy from '../../../../components/DocumentSetEventCreatedBy';

import JobField from '../JobField';

interface Props {
    documentSetId: number;
}

export default function JobDetails(props: Props): React.ReactElement {
    const { documentSetId } = props;

    return (
        <Segment className="job-segment">
            <Grid stackable relaxed columns={3}>
                <Grid.Column>
                    <JobField
                        label="Start Date"
                        value={
                            <DocumentSetEventStartDate
                                documentSetId={documentSetId}
                            />
                        }
                    />
                    <JobField
                        label="End Date"
                        value={
                            <DocumentSetEventEndDate
                                documentSetId={documentSetId}
                            />
                        }
                    />
                    <JobField
                        label="Variety"
                        value={
                            <DocumentSetEventEntityDefaultVarietyName
                                documentSetId={documentSetId}
                            />
                        }
                    />
                </Grid.Column>
                <Grid.Column>
                    <JobField
                        label="Group"
                        value={
                            <DocumentSetEventGroupName
                                documentSetId={documentSetId}
                            />
                        }
                    />
                    <JobField
                        label="Assignees"
                        value={
                            <DocumentSetAssignedUsersList
                                documentSetId={documentSetId}
                            />
                        }
                    />
                </Grid.Column>
                <Grid.Column>
                    <JobField
                        label="Status"
                        value={
                            <DocumentSetProgressBadge
                                documentSetId={documentSetId}
                            />
                        }
                    />
                    <JobField
                        label="Created On"
                        value={
                            <DocumentSetCreatedAt
                                documentSetId={documentSetId}
                            />
                        }
                    />
                    <JobField
                        label="Created By"
                        value={
                            <DocumentSetEventCreatedBy
                                documentSetId={documentSetId}
                            />
                        }
                    />
                </Grid.Column>
            </Grid>
        </Segment>
    );
}
